export const projects = [
  // ═══════════════════════════════════════════════════════════════
  // NEW PROJECTS (2025-2026)
  // ═══════════════════════════════════════════════════════════════
  {
    id: 12,
    title: "Neighborhood Guide (دليل الضاحية)",
    category: "mobile",
    status: "completed",
    featured: true,
    priority: 1,
    shortDescription:
      "Offline-first community directory connecting residents with local services, businesses, and duty pharmacies",
    description:
      "○ Built a community-driven, offline-first neighborhood directory connecting residents with local businesses, services, and duty pharmacies, featuring zero-latency UI powered by Hive local caching and Smart Delta-Sync with Supabase. ○ Implemented interactive map exploration with marker clustering, real-time open/closed status indicators based on local Syria timezone, community submission workflows with admin moderation queue, and FCM push notifications for local announcements. ○ Designed with full Arabic RTL support, Row Level Security (RLS) policies for data protection, local analytics tracking, and a comprehensive admin dashboard for content moderation and pharmacy duty scheduling.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "BLoC / Cubit",
        category: "stateManagement",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Hive (NoSQL)",
        category: "storage",
        level: "advanced",
        proficiency: 88,
      },
      {
        name: "Supabase",
        category: "backend",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "PostgreSQL (RLS)",
        category: "database",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Firebase FCM",
        category: "services",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "OpenStreetMap",
        category: "service",
        level: "intermediate",
        proficiency: 78,
      },
      {
        name: "flutter_map",
        category: "feature",
        level: "intermediate",
        proficiency: 78,
      },
      {
        name: "Edge Functions",
        category: "backend",
        level: "intermediate",
        proficiency: 75,
      },
    ],
    images: {
      thumbnail:
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780818463/background_agxoph.jpg",
      gallery: [
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780818463/background_agxoph.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819434/home1_prrnfv.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819444/home_2_glf9ie.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819508/categories_drtuxb.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819602/places-categories_yozzga.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819633/place-det-1_nsaf21.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819654/place-det-2_uvm85k.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819678/place-det-3_mcgpmx.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819703/services_iwd2gz.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819730/search1_ciub8b.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819749/search_2_lu3djq.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819778/admin_urpflw.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819794/setting1_jdi1tt.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780819810/setting2_y4m0cu.jpg",
      ],
      color: "teal",
    },
    links: {
      liveDemo: "https://aldahiya.vercel.app/",
      github: "",
      presentation: "",
      drive:
        "https://drive.google.com/drive/folders/1PTTms0S6cwumAz42Ib0R8BlxhqOSv6e1",
    },
    projectDetails: {
      type: "Personal Project",
      duration: { start: "2026-04", end: "Present", months: 1 },
      company: "Personal Project",
      client: "Local Community Residents",
      team: { size: 1, role: "Full Stack Developer" },
      budget: "Personal",
    },
    features: [
      "Offline-first architecture with zero-latency UI (Hive local caching)",
      "Smart Delta-Sync — fetches only modified records to save data/battery",
      "Interactive map explorer with marker clustering (OpenStreetMap)",
      "Real-time open/closed status based on Syria timezone (UTC+3)",
      "Duty pharmacy scheduling with automated daily transitions",
      "Community submissions with admin moderation queue",
      "FCM push notifications for local announcements and alerts",
      "Local analytics tracking (views, calls, searches)",
      "Comprehensive admin dashboard for content management",
      "Full Arabic RTL support with Cairo font",
      "Row Level Security (RLS) policies for data protection",
    ],
    challenges: [
      "Implementing offline-first Smart Delta-Sync with timestamp comparison",
      "Building custom time engine for Syria timezone calculations",
      "Designing marker clustering for performance with large datasets",
      "Handling image compression for uploads on weak cellular networks",
      "Implementing RLS policies for guest vs admin data access",
    ],
    lessons: [
      "Offline-first architecture design with Hive and Supabase",
      "Supabase RLS security policy implementation",
      "Smart Delta-Sync data synchronization patterns",
      "Community-driven platform moderation workflows",
      "OpenStreetMap integration with flutter_map",
    ],
  },
  {
    id: 16,
    title: "Radar Al-Masrouf (رادار المصروف)",
    category: "mobile",
    status: "completed",
    featured: true,
    priority: 2,
    shortDescription:
      "Complete personal finance management system — budgets, multi-currency wallets, savings goals, debt tracking, and bills management — 100% offline-first",
    description:
      "○ Built a comprehensive personal financial management platform designed for Arab families, featuring multi-currency wallets (SYP, USD, EUR, SAR, AED), smart shopping radar with price history tracking, monthly budgets with category-level alerts, and a fully automated savings vault system. ○ Implemented a complete bills management module for recurring payments (daily, weekly, monthly) with wallet-integrated auto-deduction, a smart debt management system with full wallet synchronization, and advanced financial analytics with interactive charts and month-over-month comparisons. ○ Engineered a robust backup system (manual JSON export + automated periodic backups + one-tap restore), operating 100% offline-first with local encrypted storage and zero cloud dependencies for complete privacy.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "SharedPreferences",
        category: "storage",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Hive",
        category: "storage",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "fl_chart",
        category: "visualization",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Firebase Remote Config",
        category: "services",
        level: "intermediate",
        proficiency: 75,
      },
      {
        name: "Local Notifications",
        category: "feature",
        level: "intermediate",
        proficiency: 78,
      },
      {
        name: "Material Design 3",
        category: "design",
        level: "advanced",
        proficiency: 88,
      },
      {
        name: "Google Fonts",
        category: "design",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Intl & Localization",
        category: "i18n",
        level: "advanced",
        proficiency: 85,
      },
    ],
    images: {
      thumbnail:
        "https://res.cloudinary.com/debuadvrz/image/upload/v1784316612/icon-splash_bgevpn.jpg",
      gallery: [
        "https://res.cloudinary.com/debuadvrz/image/upload/v1784316413/photo_2026-07-17_22-25-49_qq5zgz.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1784316413/photo_2026-07-17_22-25-44_v7vnls.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1784316414/photo_2026-07-17_22-25-40_nercmz.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1784316417/photo_2026-07-17_22-25-51_biosvw.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1784316414/photo_2026-07-17_22-25-42_vyr72k.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1784316415/photo_2026-07-17_22-25-38_osqgag.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1784316419/photo_2026-07-17_22-25-35_wyyult.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1784316416/photo_2026-07-17_22-25-46_exfdd2.jpg",
      ],
      color: "emerald",
    },
    links: {
      liveDemo: "",
      github: "https://github.com/laith-alskaf/HomeBuy_Manager",
      presentation: "",
      drive:
        "https://drive.google.com/drive/folders/1PTTms0S6cwumAz42Ib0R8BlxhqOSv6e1",
    },
    projectDetails: {
      type: "Personal Product",
      duration: { start: "2025-03", end: "2025-04", months: 1 },
      company: "Personal Project",
      client: "Arab Families & Individuals",
      team: { size: 1, role: "Full Stack Developer & Product Designer" },
      budget: "Personal",
    },
    features: [
      "Multi-currency wallet management (SYP, USD, EUR, SAR, AED) with instant currency exchange",
      "Smart shopping radar with 12+ built-in categories and price history tracking",
      "Monthly budgets with category-level spending alerts and rollover calculation",
      "Bills Manager for recurring obligations (daily, weekly, monthly) with wallet auto-deduction",
      "Side Balance system for separated funds with multi-currency support",
      "Savings Goals with visual progress tracking and deposit history",
      "Smart Debt management with full wallet synchronization",
      "Smart Vault for automatic and manual savings with multi-currency support",
      "Advanced financial analytics with interactive fl_chart visualizations",
      "Month-over-month spending comparison reports",
      "Professional backup system (manual JSON export, automated periodic backup, one-tap restore)",
      "100% offline-first architecture — zero cloud dependencies",
      "Privacy-first design — all data stored locally with encryption",
      "Arabic-first UI with Google Fonts (Outfit, Tajawal)",
    ],
    challenges: [
      "Designing complex multi-currency wallet logic with real-time balance synchronization",
      "Building automated debt-wallet integration for consistent financial state",
      "Implementing recurring bills payment engine with undo/rollback capability",
      "Creating responsive interactive charts for financial analytics on mobile",
      "Engineering a reliable backup/restore system with JSON serialization",
    ],
    lessons: [
      "Personal finance product design and UX for non-technical users",
      "Complex multi-entity state management with local storage",
      "fl_chart integration for production-grade financial visualizations",
      "Offline-first architecture design patterns",
      "Arabic-first mobile UI design with RTL support",
    ],
  },
  {
    id: 13,
    title: "Musafer (مسافر) — Smart Bus Booking",
    category: "mobile",
    status: "completed",
    featured: true,
    priority: 3,
    shortDescription:
      "Smart bus ticket booking platform for passengers — ATMTA Technological Solutions",
    description:
      "○ Developed a smart bus ticket booking platform enabling passengers to search for intercity trips in real-time, select seats via an interactive seat map, and receive digital QR boarding passes with instant booking confirmations. ○ Implemented OTP-based secure authentication, complete trip history archiving, and push notifications for trip status updates and schedule changes, ensuring a seamless and reliable travel experience. ○ Designed with bilingual support (Arabic/English), responsive layouts across iOS, Android, and Web, and optimized performance for smooth navigation and fast search results.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "BLoC",
        category: "stateManagement",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Dio",
        category: "networking",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "GoRouter",
        category: "navigation",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Firebase FCM",
        category: "services",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Secure Storage",
        category: "storage",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Equatable",
        category: "architecture",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Connectivity Plus",
        category: "feature",
        level: "intermediate",
        proficiency: 78,
      },
      {
        name: "Localization (l10n)",
        category: "i18n",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "GitHub Actions",
        category: "devops",
        level: "advanced",
        proficiency: 85,
      },
    ],
    images: {
      thumbnail:
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823638/dsadadsada_iebspe.jpg",
      gallery: [
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823638/dsadadsada_iebspe.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823632/login_hna4be.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823837/search-no_cjotqd.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823833/search-result_t6tjk5.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823835/history_y5yvhw.jpg",
      ],
      color: "blue",
    },
    links: {
      liveDemo: "https://www.musafer.app/",
      github: "",
      presentation: "",
      drive: "",
    },
    projectDetails: {
      type: "Commercial Product",
      duration: { start: "", end: "2026-06", months: 1 },
      company: "ATMTA Technological Solutions",
      client: "Passengers & Travelers",
      team: { size: 2, role: "Software Engineer" },
      budget: "Commercial",
    },
    features: [
      "Real-time intercity trip search with advanced filters",
      "Interactive seat map for selecting preferred placement",
      "Digital QR boarding pass with instant issuance",
      "OTP-based secure authentication",
      "Complete trip history archiving (past and upcoming)",
      "Push notifications for trip status and booking confirmations",
      "Bilingual support (Arabic / English) with full RTL",
      "Responsive layouts across iOS, Android, and Web",
      "Automated CI/CD validation on code commits (Static Analysis & Linting)",
      "Keystore-signed APK/AAB release build automation",
      "Automated web build and deployment to Linux VPS via SSH & rsync",
    ],
    challenges: [
      "Real-time seat availability synchronization across users",
      "Interactive seat map rendering and selection logic",
      "Cross-platform responsive layout consistency",
      "OTP authentication flow with secure token management",
      "Configuring Android release signing securely within GitHub repository secrets",
    ],
    lessons: [
      "Production-grade booking system architecture",
      "GoRouter advanced navigation patterns",
      "Responsive multi-platform Flutter design",
      "Automated Flutter build pipelines and keystore signing configurations",
      "Automated remote deployments using SSH and rsync",
    ],
  },
  {
    id: 14,
    title: "Masar (مسار) — Transport Operations ERP",
    category: "enterprise",
    status: "completed",
    featured: true,
    priority: 4,
    shortDescription:
      "Comprehensive transport operations ERP with 23+ feature modules — ATMTA Technological Solutions",
    description:
      "○ Developed a comprehensive transport operations ERP system with 23+ feature modules, enabling transport companies to manage offices, fleets, drivers, routes, trips, and pricing through a centralized admin dashboard. ○ Built multi-role access control (Super Admin, Supervisor, Booking Agent, Driver, Inspector) with QR ticket scanning, Bluetooth thermal receipt printing, and WhatsApp integration for efficient field operations. ○ Implemented financial and operational reporting dashboards, expense management, and station management to support data-driven decision-making and maximize operational efficiency.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "BLoC",
        category: "stateManagement",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Dio",
        category: "networking",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "GoRouter",
        category: "navigation",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Firebase FCM",
        category: "services",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "QR Code Scanner",
        category: "feature",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Bluetooth Thermal Printer",
        category: "hardware",
        level: "advanced",
        proficiency: 82,
      },
      {
        name: "PDF Generation",
        category: "feature",
        level: "intermediate",
        proficiency: 78,
      },
      {
        name: "Image Picker",
        category: "feature",
        level: "intermediate",
        proficiency: 78,
      },
      {
        name: "Localization (l10n)",
        category: "i18n",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "GitHub Actions",
        category: "devops",
        level: "advanced",
        proficiency: 85,
      },
    ],
    images: {
      thumbnail:
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780821483/logo_cjpaw3.png",
      gallery: [
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780821483/logo_cjpaw3.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780821674/splash_d4z1m1.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780821523/WhatsApp_Image_2026-06-07_at_11.33.12_AM52414_oev8pf.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780821622/dash1_qm42yt.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780821647/dash2_c10ggn.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780821768/search-trip_q9uy4f.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823880/bus-layout_jq1fbi.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823413/info-ticket1_vut75c.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823423/info-ticket2_bot5nh.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823443/create_bus_goaxqq.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823456/create-trip_p9mf8a.jpg",
      ],
      color: "indigo",
    },
    links: {
      liveDemo: "https://masar.admda.online/",
      github: "",
      presentation: "",
      drive: "",
    },
    projectDetails: {
      type: "Commercial Product",
      duration: { start: "", end: "2026-06", months: 2 },
      company: "ATMTA Technological Solutions",
      client: "Transport Companies & Fleet Managers",
      team: { size: 2, role: "Software Engineer" },
      budget: "Commercial",
    },
    features: [
      "23+ feature modules covering full transport operations",
      "Centralized admin dashboard for trip scheduling and pricing",
      "Multi-role access control (Super Admin, Supervisor, Agent, Driver, Inspector)",
      "QR ticket scanning and instant validity verification",
      "Bluetooth thermal receipt printing integration",
      "WhatsApp integration for field communication",
      "Financial and operational reporting dashboards",
      "Expense management and tracking",
      "Station and route management",
      "Bus fleet monitoring and trip status tracking",
      "Bilingual support (Arabic / English) with full RTL",
      "Automated CI/CD pipelines via GitHub Actions for validation and release packaging",
      "Auto-deployment of administrative web portal to Linux VPS via secure SSH/rsync",
    ],
    challenges: [
      "Architecting 23+ feature modules with Clean Architecture",
      "Bluetooth thermal printer hardware integration",
      "Complex multi-role permission and access control system",
      "Financial reporting accuracy and data consistency",
      "Managing cross-platform deployment credentials securely across environments",
    ],
    lessons: [
      "Enterprise ERP system architecture and design",
      "Bluetooth hardware integration in Flutter",
      "Complex role-based access control implementation",
      "Automated DevOps workflows for enterprise Flutter web applications",
      "Secure VPS synchronization configurations with GitHub Actions",
    ],
  },
  {
    id: 15,
    title: "ATMTA Corporate Website",
    category: "web",
    status: "completed",
    featured: true,
    priority: 5,
    shortDescription:
      "Professional bilingual corporate website — AI-Driven Development for ATMTA Technological Solutions",
    description:
      "○ Directed the creation of a professional bilingual (Arabic/English) corporate website for ATMTA Technological Solutions using AI-augmented development workflows, managing all content strategy, design direction, product positioning, and quality assurance. ○ The platform features seamless RTL/LTR transitions, dedicated product landing pages for Musafer and Masar, scroll-animated sections with Framer Motion micro-interactions, and a fully responsive design. ○ Delivered a production-grade, SEO-optimized platform with CI/CD pipeline deployment, WhatsApp integration, and contact forms — achieving professional results without prior Next.js experience through effective AI tool direction.",
    technologies: [
      {
        name: "Next.js (App Router)",
        category: "framework",
        level: "ai-driven",
        proficiency: 0,
      },
      {
        name: "React 19",
        category: "frontend",
        level: "ai-driven",
        proficiency: 0,
      },
      {
        name: "TypeScript",
        category: "language",
        level: "ai-driven",
        proficiency: 0,
      },
      {
        name: "Tailwind CSS v4",
        category: "styling",
        level: "ai-driven",
        proficiency: 0,
      },
      {
        name: "Framer Motion v12",
        category: "animation",
        level: "ai-driven",
        proficiency: 0,
      },
      {
        name: "AI-Driven Development",
        category: "methodology",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "GitHub Actions",
        category: "devops",
        level: "advanced",
        proficiency: 85,
      },
      { name: "PM2", category: "devops", level: "advanced", proficiency: 70 },
    ],
    images: {
      thumbnail:
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823563/WhatsApp_Image_2026-05-17_at_10.25.26_PM_w4yawr.jpg",
      gallery: [
        "https://res.cloudinary.com/debuadvrz/image/upload/v1780823563/WhatsApp_Image_2026-05-17_at_10.25.26_PM_w4yawr.jpg",
      ],
      color: "cyan",
    },
    links: {
      liveDemo: "https://atmta.sy/",
      github: "",
      presentation: "",
      drive: "",
    },
    projectDetails: {
      type: "AI-Driven Development",
      duration: { start: "2025-11", end: "2026-06", months: 7 },
      company: "ATMTA Technological Solutions",
      client: "ATMTA Corporate Identity",
      team: { size: 1, role: "Product Director & AI Workflow Manager" },
      budget: "Commercial",
    },
    features: [
      "Bilingual (Arabic / English) with seamless RTL/LTR transitions",
      "Dedicated product landing pages for Musafer and Masar",
      "Scroll-animated sections with Framer Motion micro-interactions",
      "Fully responsive design across all device types",
      "SEO-optimized with meta tags and structured content",
      "Contact form with email integration",
      "WhatsApp floating button for instant support",
      "CI/CD pipeline with GitHub Actions for linting, build verification, and deployment",
      "Next.js standalone build configuration with automated asset copy tasks",
      "Automated remote deployment and graceful server restart via PM2 on VPS",
    ],
    challenges: [
      "Defining clear requirements for AI-driven development workflow",
      "Ensuring design consistency across bilingual RTL/LTR layouts",
      "Configuring Next.js standalone output folder copies inside automated runner",
      "Gracefully restarting the Next.js process using PM2 over SSH in CI/CD pipeline",
      "Deploying standalone Next.js output to production server without downtime",
    ],
    lessons: [
      "AI-augmented development workflows and effective prompting",
      "Product management and content strategy direction",
      "Automated Node.js application process management with PM2",
      "Next.js standalone output architecture and deployment workflows",
      "Bilingual RTL web design principles",
    ],
  },
  // ═══════════════════════════════════════════════════════════════
  // EXISTING PROJECTS
  // ═══════════════════════════════════════════════════════════════
  {
    id: 1,
    title: "ReviewIQ — AI Review Intelligence Platform",
    category: "ai-powered",
    status: "completed",
    featured: true,
    priority: 4,
    shortDescription:
      "Full-stack AI-powered review management platform — Python/Flask backend, responsive web dashboard, and Flutter mobile app with NLP sentiment analysis, quality scoring, and smart notifications",
    description:
      "○ Engineered a full-stack AI-powered review intelligence platform spanning three platforms: a Python/Flask REST API backend, a responsive Vanilla JS web dashboard, and a cross-platform Flutter mobile application — all following Clean Architecture principles. ○ Integrated a multi-model NLP pipeline using Hugging Face (sentiment analysis, toxicity detection) and DeepSeek LLM (smart summaries, suggested replies, actionable insights), with real-time webhook ingestion from Tally Forms and rich Telegram Bot notifications. ○ Built comprehensive analytics dashboards across both web and mobile with interactive Chart.js/FL Chart visualizations, advanced filtering by sentiment, rating, date, and quality score, plus export to CSV/JSON and QR code generation for review collection. ○ Implemented JWT-based authentication, MongoDB Atlas storage with schema validation, and bilingual support (Arabic/English with full RTL) across all platforms.",
    technologies: [
      {
        name: "Python",
        category: "backend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Flask",
        category: "framework",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "MongoDB",
        category: "database",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Hugging Face",
        category: "ai",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "DeepSeek LLM",
        category: "ai",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Dart",
        category: "language",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "BLoC Pattern",
        category: "stateManagement",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "JavaScript (ES6+)",
        category: "frontend",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "HTML5/CSS3",
        category: "frontend",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Chart.js",
        category: "visualization",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Dio",
        category: "networking",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "JWT",
        category: "security",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Telegram Bot API",
        category: "services",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Firebase",
        category: "services",
        level: "intermediate",
        proficiency: 75,
      },
    ],
    images: {
      thumbnail:
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767707338/2_kqn7nk.png",
      gallery: [
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767707338/2_kqn7nk.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767710146/9_iflsgx.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767707339/3_japtf1.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767710147/12_r6h2c8.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767707336/4_fcmdht.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767707338/5_wz3vt5.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767710146/10_rqt5cl.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767707336/6_ajmzpv.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767707337/1_ptg2ds.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767710146/11_joyrdp.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767707338/7_wlweqa.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767710147/14_zl43pu.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767707336/8_dpkqze.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767710147/13_ogwgbe.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767710148/16_egeiay.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1767710147/15_ztupce.jpg",
      ],
      color: "blue",
    },
    links: {
      liveDemo: "https://reputation-guardianapp.vercel.app/index.html",
      github: "https://github.com/laith-alskaf/reputation-guardian",
      presentation: "",
      drive: "",
    },
    projectDetails: {
      type: "Full-Stack AI Product",
      duration: { start: "2025-6", end: "2025-8", months: 2 },
      company: "Personal Product",
      client: "Business Owners & Local Merchants",
      team: { size: 1, role: "Full Stack Developer & AI Engineer" },
      budget: "Personal",
    },

    features: [
      "AI-powered sentiment analysis (Positive / Neutral / Negative)",
      "Automated review quality scoring engine (0–100%)",
      "Profanity and toxicity detection pipeline",
      "Context relevance validation for mismatched or spam reviews",
      "AI-generated summaries and actionable business insights",
      "Smart suggested replies generation for customer engagement",
      "Real-time Telegram notifications with rich formatting",
      "Secure webhook integration with Tally Forms",
      "Multi-language support (Arabic / English) with full RTL",
      "Cross-platform dashboards (Web & Flutter Mobile)",
      "Interactive charts and analytics visualization",
      "Advanced filtering by sentiment, rating, date, and quality score",
      "QR code generation for review collection",
      "Data export to CSV and JSON formats",
      "JWT-based authentication and role security",
      "Mobile-first, fully responsive web interface",
    ],
    challenges: [
      "Integrating multiple NLP models within a single processing pipeline",
      "Handling Arabic text analysis and sentiment accuracy",
      "Implementing real-time webhook ingestion with validation and security",
      "Designing fully responsive UI with complete RTL support",
      "Managing complex application state using BLoC pattern",
      "Ensuring data consistency across web and mobile platforms",
    ],
    lessons: [
      "Production-grade AI/ML integration for NLP-based systems",
      "Applying Clean Architecture across backend and Flutter applications",
      "Scalable state management using BLoC pattern",
      "MongoDB schema design for flexible and evolving datasets",
      "Building multilingual applications with RTL-first approach",
      "Webhook security and validation best practices",
      "Designing rich notification systems using Telegram Bot API",
    ],
  },
  {
    id: 2,
    title: "Training Center Management Platform",
    category: "automation",
    status: "completed",
    featured: true,
    priority: 6,
    shortDescription:
      "Comprehensive training center management system with Telegram Bot, payment tracking, and social media automation",
    description:
      "○ Developed a production-ready training center management platform that streamlines course management, student registrations, and payment tracking through an intuitive Telegram Bot interface. ○ Implemented multi-language support (Arabic/English), admin approval workflows, Google Drive integration for course materials, and social media automation for Facebook & Instagram. ○ Designed with Clean Architecture principles, featuring domain-driven design with repositories, entities, and use cases, ensuring maintainability, scalability, and efficient operations for training center administrators.",
    technologies: [
      {
        name: "Python",
        category: "language",
        level: "advanced",
        proficiency: 75,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 80,
      },
      {
        name: "Telegram Bot API",
        category: "integration",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "MongoDB",
        category: "database",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Motor (Async)",
        category: "database",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Google APIs",
        category: "services",
        level: "intermediate",
        proficiency: 90,
      },
      {
        name: "Meta Graph API",
        category: "services",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "APScheduler",
        category: "automation",
        level: "intermediate",
        proficiency: 70,
      },
      {
        name: "Pydantic",
        category: "validation",
        level: "advanced",
        proficiency: 85,
      },
    ],
    images: {
      thumbnail: "",
      gallery: [],
      color: "blue",
    },
    links: {
      liveDemo: "",
      github: "",
      presentation: "",
      drive: "",
    },
    projectDetails: {
      type: "Full Training Project",
      duration: { start: "2024-10", end: "2024-12", months: 3 },
      company: "Private Project",
      client: "Business Owners",
      team: { size: 1, role: "Full Stack Developer" },
      budget: "Private",
    },
    features: [
      "Telegram Bot-based management interface with intuitive button navigation",
      "Multi-language support (Arabic / English) with full RTL/LTR handling",
      "Course creation and lifecycle management",
      "Student registration workflow with admin approval",
      "Payment tracking system (Unpaid / Partial / Paid)",
      "Support for multiple payment methods",
      "Syrian phone number validation system",
      "Automated notifications and 24-hour reminders",
      "Broadcast messaging system for announcements",
      "Google Drive integration for course materials storage",
      "Social media automation (Facebook & Instagram)",
      "Scheduled posts from Google Sheets",
      "Real-time statistics and operational analytics",
      "Role-based admin controls",
    ],
    challenges: [
      "Implementing asynchronous MongoDB operations using Motor",
      "Designing complex registration and approval workflows",
      "Integrating multiple third-party APIs reliably",
      "Managing real-time scheduling and task automation",
      "Handling bilingual UI with RTL and LTR consistency",
    ],
    lessons: [
      "Clean Architecture implementation for automation-heavy systems",
      "Telegram Bot UX and interaction best practices",
      "Async database handling with MongoDB and Motor",
      "Google APIs integration (Drive and Sheets)",
      "Meta Graph API integration for social media automation",
      "Designing scalable admin workflows for non-technical users",
    ],
  },
  {
    id: 3,
    title: "Purchase Management System",
    category: "enterprise",
    status: "completed",
    featured: true,
    priority: 7,
    shortDescription:
      "Professional procurement management platform for enterprises",
    description:
      "○ Developed a full-stack procurement management system for enterprise operations, featuring a multi-role approval workflow (General Manager, Finance Manager, Procurement Manager, Assistant, Auditor). ○ Implemented modules for purchase requests, vendors, items, reports, and bilingual UI (Arabic/English). ○ Designed with clean architecture, scalable backend, and responsive frontend for both Windows and Android platforms, ensuring clarity ,maintainability, and efficient collaboration between departments.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "GetX",
        category: "stateManagement",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Dio",
        category: "networking",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Node.js",
        category: "backend",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "TypeScript",
        category: "language",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Express",
        category: "framework",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "PostgreSQL",
        category: "database",
        level: "intermediate",
        proficiency: 75,
      },
      {
        name: "Firebase",
        category: "services",
        level: "intermediate",
        proficiency: 80,
      },
    ],
    images: {
      thumbnail:
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851996/Dashboard_cobttp.png",
      gallery: [
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851995/login_ckwrvy.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761852371/Mobile-_Dashboard_ra9oex.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851996/Dashboard_cobttp.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851996/drawer_uj7ig5.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851997/Purchase_Orders_l1r3k7.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851992/Purchase_Order_Details_dzcqh4.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761852372/Mobile-_Purchase_Order_Details_x5agc3.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851993/Create_User_oiljou.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851997/Users_d7k606.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851996/Vendors_awhjpm.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761852372/Mobile-_Create_Vendor_v8qlnb.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851996/Notifications_qts7k3.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851993/Items_zslgcn.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851997/Audit_Logs_tuqsna.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851992/Reports1_imkuij.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851993/Reports2_wspata.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761851994/About_Developer_bgfphf.png",
      ],
      color: "purple",
    },
    links: {
      liveDemo: "",
      github: "",
      presentation: "",
      drive: "",
    },
    projectDetails: {
      duration: { start: "2025-04", end: "2025-06", months: 2 },
      company: "Private Project",
      client: "Enterprise Client",
      team: { size: 1, role: "Full Stack Developer" },
      budget: "Private",
    },
    features: [
      "Role-based access control (General Manager, Finance, Procurement, Assistant, Auditor)",
      "Multi-stage purchase request approval workflow",
      "Vendor management with detailed profiles",
      "Item and inventory management",
      "Real-time purchase request tracking",
      "Department-level reporting and analytics",
      "Audit logs for traceability and compliance",
      "Notification system for approval actions",
      "Bilingual interface (Arabic / English) with RTL support",
      "Cross-platform support (Windows & Android)",
      "Secure authentication and authorization",
    ],
    challenges: [
      "Designing complex multi-role approval workflows",
      "Ensuring data integrity in multi-user environments",
      "Synchronizing real-time updates across platforms",
      "Handling enterprise-scale datasets efficiently",
      "Maintaining clarity and usability for non-technical users",
    ],
    lessons: [
      "Enterprise-grade application architecture design",
      "Advanced role-based access control strategies",
      "Scalable backend optimization techniques",
      "Designing auditable systems for enterprise compliance",
      "Cross-platform UI consistency in Flutter applications",
    ],
  },
  {
    id: 4,
    title: "E-Commerce Backend API",
    category: "backend",
    status: "completed",
    featured: false,
    priority: 8,
    shortDescription: "Scalable and secure e-commerce backend system",
    description:
      "Scalable and secure e-commerce backend using Node.js, TypeScript, MongoDB, PostgreSQL, JWT, and Clean Architecture. Includes authentication, product management, wishlist, and Swagger/Postman documentation.",
    technologies: [
      {
        name: "Node.js",
        category: "backend",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Express.js",
        category: "framework",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "TypeScript",
        category: "language",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "MongoDB",
        category: "database",
        level: "intermediate",
        proficiency: 85,
      },
      {
        name: "PostgreSQL",
        category: "database",
        level: "intermediate",
        proficiency: 75,
      },
      { name: "JWT", category: "security", level: "advanced", proficiency: 88 },
      {
        name: "Swagger",
        category: "documentation",
        level: "advanced",
        proficiency: 85,
      },
    ],
    images: {
      thumbnail: "/api/placeholder/400/250",
      gallery: ["/api/placeholder/600/400"],
      color: "blue",
    },
    links: {
      liveDemo:
        "https://ecommerce-backend-clean-architecture.vercel.app/api-docs/",
      github:
        "https://github.com/laith-alskaf/ecommerce-backend-clean-architecture",
      presentation: "",
      drive: "",
    },
    projectDetails: {
      duration: { start: "2024", end: "2024", months: 1 },
      company: "Personal Project",
      client: "Multiple Clients",
      team: { size: 1, role: "Backend Developer" },
      budget: "Open Source",
    },
    features: [
      "User authentication with JWT",
      "Product management",
      "Order management",
      "Wishlist functionality",
      "Role-based access control",
      "Payment integration",
      "Comprehensive API documentation",
      "Admin dashboard endpoints",
    ],
    challenges: [
      "Payment gateway integration",
      "Database optimization for high traffic",
      "Security implementation (JWT, CORS, validation)",
      "Scalability planning",
    ],
    lessons: [
      "RESTful API design patterns",
      "Security best practices (Authentication, Authorization)",
      "Database design and indexing",
      "API documentation with Swagger",
    ],
  },
  {
    id: 5,
    title: "Team Management Desktop & Mobile App",
    category: "mobile",
    status: "completed",
    featured: true,
    priority: 9,
    shortDescription:
      "Internal project for YES For Online Services - Enhanced team productivity by 30%",
    description:
      "Developed a Flutter-based desktop and mobile application for YES For Online Services that enhanced team productivity by 30% for over 20 employees on Windows and Android. This intuitive app streamlined task management by enabling seamless creation, assignment, and tracking of projects, offering a robust admin dashboard for monitoring performance. Featured real-time communication through WhatsApp-like chat powered by Socket.IO.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "GetX",
        category: "stateManagement",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Dio",
        category: "networking",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Hive",
        category: "storage",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Socket.IO",
        category: "realtime",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Firebase",
        category: "services",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Node.js",
        category: "backend",
        level: "advanced",
        proficiency: 85,
      },
    ],
    images: {
      thumbnail:
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761905378/login_yhmfml.png",
      gallery: [
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761905378/login_yhmfml.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761905095/photo_1_2025-10-31_13-01-34_s3kpyw.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761905095/photo_2_2025-10-31_13-01-34_g7fvg3.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761905096/photo_4_2025-10-31_13-01-34_rtxhow.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761905095/photo_5_2025-10-31_13-01-34_mpkgsi.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761905095/photo_7_2025-10-31_13-01-34_fjr6mj.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761905095/photo_6_2025-10-31_13-01-34_osi64g.jpg",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761905096/photo_3_2025-10-31_13-01-34_hlgyv8.jpg",
      ],
      color: "green",
    },
    links: {
      liveDemo: "",
      github: "",
      presentation: "",
      drive: "",
    },
    projectDetails: {
      duration: { start: "2023-11", end: "2024-3", months: 4 },
      company: "YES for Online Services",
      client: "Internal Use - YES For Online Services",
      team: { size: 2, role: "Lead Mobile Developer" },
      budget: "Internal",
    },
    features: [
      "Task creation, assignment, and tracking system",
      "Project and team management modules",
      "Admin dashboard for performance monitoring",
      "Real-time chat system using Socket.IO",
      "Real-time progress and status updates",
      "Email and push notification system",
      "Role-based permissions and access control",
      "Cross-platform deployment (Windows & Android)",
      "Team collaboration and productivity tools",
    ],
    challenges: [
      "Real-time data synchronization across multiple users",
      "Integrating Socket.IO with Flutter",
      "Handling offline scenarios with local caching",
      "Managing admin dashboard complexity",
      "Supporting concurrent users efficiently",
    ],
    lessons: [
      "Real-time communication implementation using Socket.IO",
      "Complex state management in large Flutter applications",
      "Performance optimization for multi-user systems",
      "Designing scalable admin dashboards",
      "Cross-platform deployment strategies",
    ],
  },
  {
    id: 6,
    title: "iDBOOK Mobile Application",
    category: "mobile",
    status: "completed",
    featured: true,
    priority: 10,
    shortDescription:
      "Google Play Release - Dynamic system for ads, polls, and posts",
    description:
      "Contributed to the development of the Orbit section in the iDBOOK mobile app for YES For Online Services. Created a dynamic system to display ads, polls, and posts, reordered by weighted priorities to maximize user engagement. Implemented timer-based logic and integrated real-time updates for post reactions and views.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "GetX",
        category: "stateManagement",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Provider",
        category: "stateManagement",
        level: "intermediate",
        proficiency: 75,
      },
      {
        name: "HTTP",
        category: "networking",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "SharedPreferences",
        category: "storage",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "QR Code",
        category: "feature",
        level: "intermediate",
        proficiency: 75,
      },
      {
        name: "SQLite",
        category: "database",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Socket.IO",
        category: "realtime",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Google Maps",
        category: "service",
        level: "intermediate",
        proficiency: 75,
      },
      {
        name: "Localization",
        category: "i18n",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Firebase",
        category: "services",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Node.js",
        category: "backend",
        level: "advanced",
        proficiency: 85,
      },
    ],
    images: {
      thumbnail: "/api/placeholder/400/250",
      gallery: ["/api/placeholder/600/400"],
      color: "blue",
    },
    links: {
      liveDemo:
        "https://play.google.com/store/apps/details?id=com.yesforonlineservices.idbook",
      github: "",
      presentation: "",
      drive: "",
    },
    projectDetails: {
      duration: { start: "2023-11", end: "2024-10", months: 12 },
      company: "YES for Online Services",
      client: "Public - Google Play Store",
      team: { size: 3, role: "Mobile Developer" },
      budget: "Commercial",
    },
    features: [
      "Dynamic ad/poll/post display system",
      "Weighted priority algorithm",
      "Real-time reactions and views",
      "QR code scanning",
      "Google Maps integration",
      "Multi-language support",
      "User authentication",
      "Real-time notifications",
      "Offline support",
    ],
    challenges: [
      "Implementing weighted priority system",
      "Real-time updates optimization",
      "QR code integration",
      "Performance with large datasets",
      "User engagement maximization",
    ],
    lessons: [
      "Advanced algorithm implementation",
      "Real-time data management",
      "User engagement optimization",
      "Integration with multiple services",
    ],
  },
  {
    id: 7,
    title: "iDBOOK Agent Mobile Application",
    category: "mobile",
    status: "completed",
    featured: true,
    priority: 11,
    shortDescription: "QR code-based payment activation application",
    description:
      "Payment activation application that utilizes QR code scanning. Allows users to activate plans by scanning corresponding QR codes. Includes history feature to track paid plans, requires location activation and sufficient balance. Features login page and sends SMS messages for convenient mobile access.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "GetX",
        category: "stateManagement",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "HTTP",
        category: "networking",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "SharedPreferences",
        category: "storage",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "QR Code",
        category: "feature",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Socket.IO",
        category: "realtime",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Localization",
        category: "i18n",
        level: "intermediate",
        proficiency: 80,
      },
    ],
    images: {
      thumbnail: "/api/placeholder/400/250",
      gallery: ["/api/placeholder/600/400"],
      color: "purple",
    },
    links: {
      liveDemo: "",
      github: "",
      presentation: "",
      drive: "",
    },
    projectDetails: {
      duration: { start: "2023-11", end: "2024-10", months: 12 },
      company: "YES for Online Services",
      client: "Internal Use",
      team: { size: 1, role: "Mobile Developer" },
      budget: "Internal",
    },
    features: [
      "QR code scanning for plan activation",
      "Plan history tracking",
      "Location activation",
      "Balance verification",
      "User authentication",
      "SMS notifications",
      "Multi-language support",
      "Real-time plan status",
    ],
    challenges: [
      "QR code scanning accuracy",
      "Location verification",
      "SMS integration",
      "Real-time balance updates",
      "Security for payment activation",
    ],
    lessons: [
      "QR code implementation",
      "Location services integration",
      "SMS API integration",
      "Payment security",
    ],
  },
  {
    id: 8,
    title: "Car Service App",
    category: "mobile",
    status: "completed",
    featured: true,
    priority: 12,
    shortDescription: "Graduation project - Parking and maintenance services",
    description:
      "Comprehensive app combining parking and maintenance services created to let users easily book spots and locate service centers, improving user experience and maintenance efficiency. Provides detailed administrator statistics to optimize operations while adhering to clean coding practices for improved maintainability and scalability.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Firebase",
        category: "services",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "GetX",
        category: "stateManagement",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Google Maps",
        category: "service",
        level: "intermediate",
        proficiency: 75,
      },
      {
        name: "Localization",
        category: "i18n",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Node.js",
        category: "backend",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Express",
        category: "framework",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "MongoDB",
        category: "database",
        level: "intermediate",
        proficiency: 85,
      },
      {
        name: "Socket.io",
        category: "realtime",
        level: "advanced",
        proficiency: 85,
      },
    ],
    images: {
      thumbnail:
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855489/Login_wgw1cg.png",
      gallery: [
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855485/Landing_View_sfituk.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855489/Login_wgw1cg.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855479/Create1_ltxjts.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855147/Create2_jolcvl.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855467/Create3_wlfuc6.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855488/Home_bkckai.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855066/Parking1_qvol4l.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855100/Parking2_gjmf8b.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855458/Parking3_ytmlxi.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855461/Parking4_kaqbsd.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855462/Parking5_nhfyqp.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855475/History_xdfvqg.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855114/Repair1_vczxpq.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855481/Repair2_h4epq0.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855152/Repair3_w7ymoi.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855488/Repair4_mbfi8x.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855077/Profile_w473wx.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855475/Dashboard_ahqlu4.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855133/Admin_Profile_ohre62.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855464/All_Orders_eduz4g.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761855021/Parking_Order_Description_ke1sau.png",
      ],
      color: "orange",
    },
    links: {
      liveDemo: "",
      github: "https://github.com/laith-alskaf/car_service",
      presentation: "",
      drive:
        "https://drive.google.com/file/d/1Rjn1LTpQdQ8RsdIz5QHHQBmoz75SWSUs/view?usp=drive_link",
    },
    projectDetails: {
      duration: { start: "2023-09", end: "2024-01", months: 5 },
      company: "University of Homs",
      client: "Graduation Project",
      team: { size: 2, role: "Lead Developer" },
      budget: "Academic",
    },
    features: [
      "Parking spot booking",
      "Service center location finder",
      "User rating and reviews",
      "Admin statistics dashboard",
      "Real-time booking updates",
      "Google Maps integration",
      "Service history",
      "Multi-language support",
    ],
    challenges: [
      "Real-time booking management",
      "Location-based services",
      "Admin dashboard complexity",
      "Database optimization",
    ],
    lessons: [
      "Full-stack application development",
      "Location-based services",
      "Real-time data management",
      "Admin dashboard design",
    ],
  },
  {
    id: 9,
    title: "Food Ordering App",
    category: "mobile",
    status: "completed",
    featured: false,
    priority: 13,
    shortDescription: "Freelance project - Cross-platform food ordering",
    description:
      "A cross-platform food-ordering application with real-time order updates, secure payments, and location-based restaurant discovery. Includes user authentication, cart management, and live-tracked orders with a scalable, modular architecture that is easy to maintain and a simple user experience.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "BLoC",
        category: "stateManagement",
        level: "advanced",
        proficiency: 85,
      },
      {
        name: "Firebase",
        category: "services",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Google Maps",
        category: "service",
        level: "intermediate",
        proficiency: 75,
      },
      {
        name: "Stripe",
        category: "payment",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Hive",
        category: "storage",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Push Notifications",
        category: "feature",
        level: "intermediate",
        proficiency: 80,
      },
    ],
    images: {
      thumbnail: "/api/placeholder/400/250",
      gallery: ["/api/placeholder/600/400"],
      color: "red",
    },
    links: {
      liveDemo: "",
      github: "",
      presentation: "",
      drive: "",
    },
    projectDetails: {
      duration: { start: "2023-09", end: "2024-1", months: 5 },
      company: "Freelance",
      client: "Private Client",
      team: { size: 2, role: "Full Stack Developer" },
      budget: "Commercial",
    },
    features: [
      "Restaurant discovery with maps",
      "Real-time order tracking",
      "Secure payment integration (Stripe)",
      "User authentication",
      "Cart management",
      "Order history",
      "Push notifications",
      "Offline caching",
      "User ratings and reviews",
    ],
    challenges: [
      "Real-time order updates",
      "Payment security",
      "Location-based restaurant discovery",
      "Order tracking accuracy",
      "Performance optimization",
    ],
    lessons: [
      "Payment gateway integration",
      "Real-time tracking implementation",
      "Location-based services",
      "BLoC state management",
    ],
  },
  {
    id: 10,
    title: "Darrebni National Platform",
    category: "mobile",
    status: "completed",
    featured: true,
    priority: 14,
    shortDescription:
      "Training course project - Unified educational platform for national exams",
    description:
      "Developed as a final project at Darrebni Company to deliver a unified educational platform for Syrian students to prepare for the National Unified Exam. Collaborative project focusing on clean architecture, responsive user interface, and smooth navigation. Quality ensured through cross-checking and testing.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "Clean Architecture",
        category: "architecture",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "GetX",
        category: "stateManagement",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "Hive",
        category: "storage",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "PDF",
        category: "feature",
        level: "intermediate",
        proficiency: 75,
      },
      {
        name: "Localization",
        category: "i18n",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "Firebase",
        category: "services",
        level: "intermediate",
        proficiency: 80,
      },
    ],
    images: {
      thumbnail:
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908290/splash_screen_tfldwb.png",
      gallery: [
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908290/splash_screen_tfldwb.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908286/login_tgymt4.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908289/signup_q8w7y8.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908291/all-home_hzsysf.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908292/IT_je4sjg.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908287/notification_w2k3zr.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908285/ITQ_Defult_wkd4bw.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908286/ITQ_true_ch4rkp.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908286/ITQ_error_x7nfas.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908287/result_1_kd5u4g.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908288/result_q1yxuc.png",
        "https://res.cloudinary.com/debuadvrz/image/upload/v1761908290/years_fbefae.png",
      ],
      color: "indigo",
    },
    links: {
      liveDemo: "https://reputation-guardianapp.vercel.app/",
      github: "https://github.com/laith-alskaf/darrebni_national-Project",
      presentation: "",
      drive:
        "https://drive.google.com/drive/folders/1lBLHT1xul4L6_PJaED8mqNH1K2m4M-E7",
    },
    projectDetails: {
      duration: { start: "2023-09", end: "2023-10", months: 2 },
      company: "Darrebni Company",
      client: "Educational Platform",
      team: { size: 2, role: "Lead Developer" },
      budget: "Training Project",
    },
    features: [
      "Organized educational resources",
      "Structured exam preparation content",
      "PDF viewing and management",
      "Progress tracking",
      "Multi-language support",
      "Offline access",
      "Search functionality",
      "Bookmarking system",
    ],
    challenges: [
      "Large PDF file handling",
      "Organizing complex content structure",
      "Performance optimization",
      "Team collaboration",
      "Testing thoroughness",
    ],
    lessons: [
      "Content management systems",
      "PDF integration in Flutter",
      "Team coordination",
      "Quality assurance processes",
    ],
  },
  {
    id: 11,
    title: "BetterMe - Health Application",
    category: "mobile",
    status: "completed",
    featured: false,
    priority: 15,
    shortDescription:
      "University final year project - AI-powered health and wellness app",
    description:
      "A health application developed to encourage users to adopt healthier habits through smart reminders and wellness insights. Includes BMI calculations, health tips, FAQs, and an AI-powered assistant using ChatGPT 3.5 for personalized guidance, with focus on intuitive UX and accessibility.",
    technologies: [
      {
        name: "Flutter",
        category: "frontend",
        level: "advanced",
        proficiency: 95,
      },
      {
        name: "SharedPreferences",
        category: "storage",
        level: "intermediate",
        proficiency: 80,
      },
      {
        name: "GetX",
        category: "stateManagement",
        level: "advanced",
        proficiency: 90,
      },
      {
        name: "ChatGPT 3.5 API",
        category: "ai",
        level: "intermediate",
        proficiency: 75,
      },
      {
        name: "Health Metrics",
        category: "feature",
        level: "intermediate",
        proficiency: 75,
      },
    ],
    images: {
      thumbnail: "/api/placeholder/400/250",
      gallery: ["/api/placeholder/600/400"],
      color: "green",
    },
    links: {
      liveDemo:
        "https://drive.google.com/file/d/1SI0YkpNqgf8mo8CEUTTJnMwzn7BshkD2/view?usp=drive_link",
      github: "https://github.com/laith-alskaf/better-me",
      presentation: "",
      drive:
        "https://drive.google.com/file/d/1SK_HfO2qXODXZddWtRbWFQguTMDQ9jsJ/view?usp=drive_link",
    },
    projectDetails: {
      duration: { start: "2023-12", end: "2024-03", months: 4 },
      company: "University of Homs",
      client: "Final Year Project",
      team: { size: 2, role: "Mobile Developer" },
      budget: "Academic",
    },
    features: [
      "BMI calculation and tracking",
      "AI health tips and guidance",
      "ChatGPT 3.5 integration",
      "Smart reminders",
      "Wellness insights",
      "Health FAQ system",
      "Progress tracking",
      "Personalized recommendations",
    ],
    challenges: [
      "ChatGPT API integration",
      "Health metrics accuracy",
      "AI response optimization",
      "User privacy",
      "Real-time reminders",
    ],
    lessons: [
      "AI/ML integration",
      "API usage best practices",
      "Health data handling",
      "Personalization algorithms",
    ],
  },
];
